import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

export type PlanListingProps = {
  id?: number
  servicesIds?: string
  maxCoverage?: string
}

export const getPlanListingForQuote = async (params: PlanListingProps) => {
  return axios.get(endpoints.getPlanForQuote, { params })
}
export const useGetPlanListingForQuote = (params?: PlanListingProps) => {
  return useQuery({
    queryKey: [ApiKey.planListing, ApiKey.list, params],
    queryFn: () => getPlanListingForQuote(params || {}),
    // enabled: !!params?.id,
    select: data => {
      const firstPlan = data.data.plans[0] ?? {}
      Object.assign(firstPlan, {
        coveragePlans: firstPlan.options ?? [],
      })
      return { ...data, firstPlan }
    },
  })
}
